
import getNotifications from './getNotifications'
import state from './intervalState'

// Fetch each x minutes
const TIME = 10 * 60 * 1000

// Interval ids are per tab, so they live in module state, not localStorage:
// a shared key let one tab overwrite or clear another tab's interval.
const fetchNotifications = () => {
  if (state.interval) {
    return state.interval
  }
  state.interval = setInterval(() => getNotifications(), TIME)
  return state.interval
}

export default fetchNotifications



// WEBPACK FOOTER //
// ./src/services/notification/fetchNotifications.js